/**
 * HazardsSection — cached course hazards with position + dimensions.
 */

import React from 'react';
import { Section, Row } from '../RaceDebugPrimitives';

const COLOR = '#e74c3c';

interface HazardLike {
  id: string;
  kind: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export const HazardsSection: React.FC<{
  hazards: HazardLike[];
}> = ({ hazards }) => (
  <Section title={`Hazards (${hazards.length})`} color={COLOR}>
    {hazards.length === 0
      ? <Row label="—" value="none cached" valueColor="#666" />
      : hazards.map((h) => (
        <Row key={h.id}
             label={h.kind}
             value={`(${h.x},${h.y}) ${h.width}×${h.height}`}
             valueColor="#aaa" />
      ))}
  </Section>
);
